import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTravel } from 'v3/pages/Travel';
import { FaArrowDown, FaArrowUp } from 'react-icons/fa';
import { Text } from 'v3/components';
import { ToggleDiv } from '../styles';

export function FooterDetails() {
  const travel = useTravel();

  const [toggleObs, setToggleObs] = useState({
    policy: false,
    coopercarga: false,
    driver: false,
    checklistValidity: false,
  });

  return (
    <Col md={12} className="my-2">
      <Row md={12}>
        <Col md={6} sm={12} className="my-2">
          <ToggleDiv onClick={() => setToggleObs((old) => ({ ...old, policy: !old?.policy }))}>
            {!toggleObs?.policy ? <FaArrowUp /> : <FaArrowDown />}
            <Text color="dark" weight={500}>
              Regras Apólice / PGR
            </Text>
          </ToggleDiv>
          {!toggleObs?.policy ? (
            <Text type="regular" color="gray" as="p" className="mt-2">
              {travel?.data?.policyInfo?.range?.obs || 'Não informado'}
            </Text>
          ) : null}
        </Col>
        <Col md={6} sm={12} className="my-2">
          <ToggleDiv onClick={() => setToggleObs((old) => ({ ...old, driver: !old?.driver }))}>
            {!toggleObs?.driver ? <FaArrowUp /> : <FaArrowDown />}
            <Text color="dark" weight={500}>
              Orientações motorista
            </Text>
          </ToggleDiv>
          {!toggleObs?.driver ? (
            <Text type="regular" color="gray" as="p" className="mt-2">
              {travel?.data?.policyInfo?.range?.driverGuide || 'Não informado'}
            </Text>
          ) : null}
        </Col>
        <Col md={6} sm={12} className="my-2">
          <ToggleDiv
            onClick={() =>
              setToggleObs((old) => ({
                ...old,
                checklistValidity: !old?.checklistValidity,
              }))
            }
          >
            {!toggleObs?.checklistValidity ? <FaArrowUp /> : <FaArrowDown />}
            <Text color="dark" weight={500}>
              Validade Checklist / Pesquisa e consulta
            </Text>
          </ToggleDiv>
          {!toggleObs?.checklistValidity ? (
            <Text type="regular" color="gray" as="p" className="mt-2">
              {travel?.data?.policyInfo?.range?.checklistValidity || 'Não informado'}
            </Text>
          ) : null}
        </Col>
        <Col md={6} sm={12} className="my-2">
          <ToggleDiv
            onClick={() => setToggleObs((old) => ({ ...old, coopercarga: !old?.coopercarga }))}
          >
            {!toggleObs?.coopercarga ? <FaArrowUp /> : <FaArrowDown />}
            <Text color="dark" weight={500}>
              Observações Coopercarga
            </Text>
          </ToggleDiv>
          {!toggleObs?.coopercarga ? (
            <Text type="regular" color="gray" as="p" className="mt-2">
              {travel?.data?.policyInfo?.range.obsCompany || 'Não informado'}
            </Text>
          ) : null}
        </Col>
      </Row>
    </Col>
  );
}
